<!-- 学校管理 -->
<template>
    <div>
        <el-card class="box-card">
            <div class="text item">
                <el-row>
                    <el-col :span="24">
                        <div class="grid-content bg-purple">
                            <el-form :inline="true" class="demo-form-inline" size="small"
                                style="text-align: left;margin-top:5px;height:30px" ref="Searchform" :model="Search">
                                <el-form-item label="学校查询" prop="school_name">
                                    <el-input v-model="Search.school_name" placeholder="请输入学校名" clearable></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button icon="el-icon-search" type="primary" size="mini"
                                        @click="getSchoolList()">查询</el-button>
                                    <el-button icon="el-icon-refresh" size="mini" @click="ClearSearchform()">重置</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="grid-content bg-purple">
                            <el-button icon="el-icon-plus" type="primary" size="mini"
                                @click="Add_dialog = true">新增</el-button>
                            <el-button size="mini" @click="Bulkimport()">批量导入</el-button>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="grid-content bg-purple-light">
                            <el-table 
                                :data="tableData_school" 
                                border 
                                style="width: 100%"
                                max-height="600">
                                <el-table-column prop="schoolName" label="学校名" width="180" show-overflow-tooltip>
                                </el-table-column>
                                <el-table-column prop="schoolAddress" label="学校地址" min-width="200" show-overflow-tooltip>
                                </el-table-column>
                                <el-table-column prop="operatingTime" label="运营时间" width="120" align="center">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.operatingTime || '11:00-19:30' }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="orderTimeout" label="超时时间" width="100" align="center">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.orderTimeout || 30 }}分钟</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="orderStrategy" label="处理策略" width="120" align="center">
                                    <template slot-scope="scope">
                                        <el-tag v-if="scope.row.orderStrategy == 0 || scope.row.orderStrategy == null" type="primary" size="small">自动派单</el-tag>
                                        <el-tag v-if="scope.row.orderStrategy == 1" type="warning" size="small">超时退款</el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="status" label="状态" width="90" align="center">
                                    <template slot-scope="scope">
                                        <el-tag v-if="scope.row.status == 0" type="success" size="small">启用</el-tag>
                                        <el-tag v-if="scope.row.status == 1" type="danger" size="small">禁用</el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" width="180" align="center" fixed="right">
                                    <template slot-scope="scope">
                                        <el-button type="primary" icon="el-icon-edit-outline" size="mini"
                                            @click="toUpdate(scope.row)">修改</el-button>
                                        <el-button type="danger" icon="el-icon-delete" size="mini"
                                            @click="toDelete(scope.row)">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 20px;">
                    <el-col :span="24">
                        <div style="text-align: center;">
                            <el-pagination 
                                v-if="tableData_school.length != 0"
                                background 
                                layout="total, prev, pager, next, jumper" 
                                :total="total" 
                                :current-page="queryObj.page"
                                :page-size="queryObj.limit"
                                @size-change="handleSizeChange" 
                                @current-change="handleSizeChange">
                            </el-pagination>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </el-card>
        <!-- 新增对话框 -->
        <el-dialog title="新增学校" :visible.sync="Add_dialog" width="40%" :before-close="handleClose" center>
            <el-form ref="addform" :model="Addform" label-width="80px">
                <el-form-item label="学校名称" prop="schoolName" :rules="rules">
                    <el-input v-model="Addform.schoolName"></el-input>
                </el-form-item>
                <el-form-item label="学校地址" prop="schoolAddress" :rules="rules">
                    <el-input v-model="Addform.schoolAddress"></el-input>
                </el-form-item>
                <el-form-item label="经纬度" prop="latitude" :rules="rules">
                    <el-col :span="11">
                        <el-input v-model="Addform.latitude" placeholder="填写纬度" style="width: 100%;"></el-input>
                    </el-col>
                    <el-col class="line" :span="2" style="display:flex;justify-content:center;">,</el-col>
                    <el-col :span="11">
                        <el-form-item prop="longitude" :rules="rules"> <el-input v-model="Addform.longitude"
                                placeholder="填写经度" style="width: 100%;"></el-input></el-form-item>
                    </el-col>
                </el-form-item>
                <el-form-item label="运营时间" prop="operatingTime">
                    <el-input v-model="Addform.operatingTime" placeholder="格式：HH:mm-HH:mm，如：11:00-19:30"></el-input>
                    <span style="font-size: 12px; color: #999;">示例：11:00-19:30</span>
                </el-form-item>
                <el-form-item label="超时时间" prop="orderTimeout">
                    <el-input-number v-model="Addform.orderTimeout" :min="1" :max="120" label="订单超时时间（分钟）"></el-input-number>
                    <span style="font-size: 12px; color: #999; margin-left: 10px;">分钟</span>
                </el-form-item>
                <el-form-item label="处理策略" prop="orderStrategy">
                    <el-radio-group v-model="Addform.orderStrategy">
                        <el-radio :label="0">自动派单</el-radio>
                        <el-radio :label="1">超时退款</el-radio>
                    </el-radio-group>
                    <div style="font-size: 12px; color: #999; margin-top: 5px;">
                        <span v-if="Addform.orderStrategy === 0">超时后自动派单给负责人</span>
                        <span v-if="Addform.orderStrategy === 1">超时后自动退款给用户</span>
                    </div>
                </el-form-item>
                <el-form-item label="是否启用" prop="status">
                    <el-switch v-model="Addform.status" active-color="#13ce66" inactive-color="#ff4949" active-value="0"
                        inactive-value="1"></el-switch>
                </el-form-item>
                <el-form-item>
                    <el-button icon="el-icon-refresh" @click="ClearAddform()">重置</el-button>
                </el-form-item>
            </el-form>
            <!-- <span>这是一段信息</span> -->
            <span slot="footer" class="dialog-footer">
                <el-button icon="el-icon-close" type="danger" @click="Add_dialog = false">取 消</el-button>
                <el-button icon="el-icon-check" type="success" @click="AddSchool()">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 修改对话框 -->
        <el-dialog title="修 改" :visible.sync="Update_dialog" width="40%" :before-close="handleClose" center>
            <el-form ref="updateform" :model="Updateform" :rules="rules" label-width="80px">
                <el-form-item label="学校名称" prop="schoolName" :rules="rules">
                    <el-input v-model="Updateform.schoolName"></el-input>
                </el-form-item>
                <el-form-item label="学校地址" prop="schoolAddress" :rules="rules">
                    <el-input v-model="Updateform.schoolAddress"></el-input>
                </el-form-item>
                <el-form-item label="经纬度" prop="latitude" :rules="rules">
                    <el-col :span="11">
                        <el-input v-model="Updateform.latitude" placeholder="填写纬度" style="width: 100%;"></el-input>
                    </el-col>
                    <el-col class="line" :span="2" style="display:flex;justify-content:center;">,</el-col>
                    <el-col :span="11">
                        <el-form-item prop="longitude" :rules="rules"> <el-input v-model="Updateform.longitude" placeholder="填写经度" style="width: 100%;"></el-input></el-form-item>
                    </el-col>
                </el-form-item>
                <el-form-item label="运营时间" prop="operatingTime">
                    <el-input v-model="Updateform.operatingTime" placeholder="格式：HH:mm-HH:mm，如：11:00-19:30"></el-input>
                    <span style="font-size: 12px; color: #999;">示例：11:00-19:30</span>
                </el-form-item>
                <el-form-item label="超时时间" prop="orderTimeout">
                    <el-input-number v-model="Updateform.orderTimeout" :min="1" :max="120" label="订单超时时间（分钟）"></el-input-number>
                    <span style="font-size: 12px; color: #999; margin-left: 10px;">分钟</span>
                </el-form-item>
                <el-form-item label="处理策略" prop="orderStrategy">
                    <el-radio-group v-model="Updateform.orderStrategy">
                        <el-radio :label="0">自动派单</el-radio>
                        <el-radio :label="1">超时退款</el-radio>
                    </el-radio-group>
                    <div style="font-size: 12px; color: #999; margin-top: 5px;">
                        <span v-if="Updateform.orderStrategy === 0">超时后自动派单给负责人</span>
                        <span v-if="Updateform.orderStrategy === 1">超时后自动退款给用户</span>
                    </div>
                </el-form-item>
                <el-form-item label="是否启用" prop="status">
                    <el-switch v-model="Updateform.status" active-color="#13ce66" inactive-color="#ff4949" active-value="0"
                        inactive-value="1"></el-switch>
                </el-form-item>
            </el-form>
            <!-- <span>这是一段信息</span> -->
            <span slot="footer" class="dialog-footer">
                <el-button icon="el-icon-close" type="danger" @click="Update_dialog = false">取 消</el-button>
                <el-button icon="el-icon-check" type="success" @click="UpdateSchool()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>

export default {
    data() {
        return {
            Search: {//搜索内容
                school_name: '',
                school_id: null,
                status: null
            },
            total:0,//分页总条目
            tableData_school: [],//表格数据(学校)
            Add_dialog: false,//新增对话框
            queryObj: {//分页渲染条件
                limit: 8,//行
                page: 1,//页数
                query: "",//条件
            },
            Addform: {//新增表单
                schoolName: '',
                schoolAddress: '',
                latitude: '',
                longitude: '',
                operatingTime: '11:00-19:30',
                orderTimeout: 30,
                orderStrategy: 0,
                status: '0'
            },
            //验证规则
            rules:
                [
                    { required: true, message: "请输入内容", trigger: 'blur' },
                    { pattern: !/[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi, message: "请输入合法字符", trigger: "blur" }
                ]
            ,
            Update_dialog: false,//修改对话框
            Updateform: {},//修改表单
        };
    },
    mounted() {
        this.getSchoolList()
    },
    methods: {
        // 修改学校
        async UpdateSchool() {
            const { data: res } = await this.$http.post('school/updateSchool', this.Updateform);
            if (res.code == 200) {
                this.$message({ type: "success", message: "修改学校成功！" })
                this.getSchoolList()
            } else {
                this.$message({ type: "error", message: "修改学校失败！" })
                this.getSchoolList()
            }
            this.Update_dialog=false
        },

        //分页交互调用事件
        handleSizeChange(newPage) {
            this.queryObj.page = newPage;
            this.getSchoolList();
        },
        // 增加学校
        async AddSchool() {
            const { data: res } = await this.$http.post('school/addSchool', this.Addform);
            if (res.code == 200) {
                this.$message({ type: "success", message: "新增学校成功！" })
                this.getSchoolList()
            } else {
                this.$message({ type: "error", message: "新增学校失败！" })
                this.getSchoolList()
            }
            this.Add_dialog=false
        },
        // 点击删除
        toDelete(Data) {
            this.$confirm('确定删除？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const { data: res } = await this.$http.delete('school/delSchool', {
                    params: {
                        id: Data.schoolId,
                    }
                });
                if (res.code == 200) {
                    this.$message({ type: "success", message: "删除成功!" })
                    this.getSchoolList()
                }
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        // 点击修改
        toUpdate(Data) {
            this.Updateform = Data
            this.Update_dialog = true
        },
        // 批量导入
        Bulkimport() {
            this.$message.warning("该功能暂未开发!")
        },
        // 重置新增表单
        ClearAddform() {
            console.log("重置新增表单");
            this.$refs.addform.resetFields()
        },
        // 重置搜索表单
        ClearSearchform() {
            console.log("重置搜索表单");
            this.$refs.Searchform.resetFields()
        },
        // 拼接字符串条件
        Query(Str) {
            for (var key in Str) {
                if (Str[key] == '' || Str[key] == null) {
                    delete Str[key]
                }
            }
            let str = JSON.stringify(Str).replace(/(\{")/g, "").replace(/(\":)/g, ' like ').replace(/}/g, '').replace(/,"/g, ' and ').replace(/{/g, '').replace(/"/g, '%"').replace('like %"', 'like "%');
            return str
        },
        // 重新渲染表格
        // 渲染表格数据(学校)数据
        async getSchoolList() {
            let str = this.Query(this.Search);
            // console.log(str.length);
            this.queryObj.query = str
            const { data: res } = await this.$http.get('/school/getSchoolList',
                {
                    params: this.queryObj
                });
            // console.log(res)
            this.tableData_school = res.data.children;
            this.total = res.data.total
        },

        // 对话框关闭
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                })
                .catch(_ => { });
        }
    }
}
</script>
<style>
body {
    background: rgb(242, 242, 242);
}
</style>
<style scoped>
.text {
    font-size: 14px;
}

.item {
    margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.clearfix:after {
    clear: both
}

.box-card {
    width: 100%;
}

.grid-content {
    margin: 20px 0;
}
</style>

